var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.icon
    ? _c(
        "md-button",
        {
          staticClass: "md-just-icon md-round",
          class: _vm.buttonColor,
          attrs: {
            title:
              _vm.error && _vm.error.message
                ? _vm.error.message
                : "Questions Mapping",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.updateQuestionsMapping()
            },
          },
        },
        [
          _c("md-icon", [_vm._v(_vm._s(_vm.icon))]),
          _vm.error.message
            ? _c("md-tooltip", [_vm._v(_vm._s(_vm.error.message))])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }